import React from 'react';

/**
 * Pastille du sourcing automatique d'un besoin.
 *
 * À la création d'un besoin (ou à l'ajout de son JD), le serveur lance seul
 * une recherche : top 5 du vivier interne + top 5 LinkedIn si le module est
 * actif. Le front n'a RIEN à déclencher — cette pastille se contente de dire
 * où en est l'automatisme, d'après le champ `sourcing_auto` du besoin.
 *
 * Règles tenues ici, contrat back :
 *  - `pastille` est le libellé prêt à afficher : repris TEL QUEL, jamais
 *    recomposé ;
 *  - `sourcing_auto` absent ou null → rien du tout (besoin antérieur à la
 *    fonctionnalité, ou automatisme coupé par l'administrateur) ;
 *  - couleur par `statut` : lancé = vert, en cours = neutre animé,
 *    non lancé = orange (le libellé porte déjà la raison) ;
 *  - le libellé entier puis le détail des couches vont en info-bulle (une
 *    liste étroite peut couper le libellé) ; « module désactivé » y est un
 *    état normal, pas une erreur.
 */

const BI = ({ icon, style }) => <i className={`bi bi-${icon}`} style={style} />;

const COUCHE_LIBELLE = {
  lance: 'lancé',
  deja_en_cours: 'déjà en cours',
  module_desactive: 'module désactivé',
  erreur: 'erreur',
};

const TONS = {
  lance: { bg: 'rgba(22,163,74,0.13)', fg: '#16a34a', icon: 'check-circle-fill' },
  en_cours: { bg: 'var(--chip-bg, rgba(120,120,128,0.12))', fg: 'var(--text-2, #4b5563)', icon: 'arrow-repeat' },
  non_lance: { bg: 'rgba(217,119,6,0.13)', fg: '#b45309', icon: 'exclamation-circle' },
};

export default function PastilleSourcingAuto({ sourcingAuto, style }) {
  const sa = sourcingAuto;
  if (!sa || typeof sa !== 'object' || !sa.pastille) return null;
  const ton = TONS[sa.statut] || TONS.non_lance;

  // Info-bulle : l'état de chaque couche, avec les mots du contrat.
  const couches = sa.couches || {};
  const detail = [
    couches.erpia?.statut ? `Vivier interne : ${COUCHE_LIBELLE[couches.erpia.statut] || couches.erpia.statut}` : null,
    couches.linkedin?.statut ? `LinkedIn : ${COUCHE_LIBELLE[couches.linkedin.statut] || couches.linkedin.statut}` : null,
  ].filter(Boolean).join(' · ');
  // Le libellé entier ouvre l'info-bulle : une liste étroite peut le couper.
  const bulle = [sa.pastille, detail].filter(Boolean).join('\n');

  return (
    <span title={bulle} className="psa-pastille" data-statut={sa.statut || 'non_lance'}
      style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', fontSize: '11px', fontWeight: 600, padding: '2px 8px', borderRadius: '6px', background: ton.bg, color: ton.fg, whiteSpace: 'nowrap', flex: 'none', ...style }}>
      <BI icon={ton.icon} style={{ fontSize: '10px', ...(sa.statut === 'en_cours' ? { display: 'inline-block', animation: 'psa-spin .9s linear infinite' } : {}) }} />
      {sa.pastille}
      {sa.statut === 'en_cours' && <style>{'@keyframes psa-spin{to{transform:rotate(360deg)}}'}</style>}
    </span>
  );
}
